/** @format */

import styled from "styled-components";

const Wrapper = styled.div`
  margin: 100px 0px;
  .border {
    margin-top: 70px;
  }

  @media (max-width: 1024px) {
    margin-top: 0;
  }
  .faq {
    display: grid;
    display: grid;
    grid-template-columns: 1fr 5fr;
    grid-gap: 60px;

    @media (max-width: 1024px) {
      grid-template-columns: 1fr;
    }
    .left-section {
      margin-top: 40px;
      @media (max-width: 1024px) {
        text-align: center;
      }
      h3 {
        text-transform: uppercase;
        margin: 10px 0;

        line-height: 1.5;
        @media (max-width: 1225px) {
          font-size: 40px;
        }
        @media (max-width: 1195px) {
          font-size: 30px;
        }
      }

      .Faqs {
        font-size: 35px;

        color: white;
        margin-bottom: 20px;
      }
      .paraLeft {
        font-size: 18px;
        line-height: 27px;
      }
      p {
        strong {
          font-size: 18px;
          line-height: 2;
        }
      }
      .description {
        margin-top: 15px;
        line-height: 1.9;
        color: #969697;
      }
      a {
        margin-top: 30px;
        padding-left: 60px;
        padding-right: 60px;
        text-decoration: none;
        display: inline-block;
      }
    }
  }

  .accordion-container {
    width: 100%;
    border-bottom: 1px solid #dec263;

    box-shadow: 0px 4px 43px rgba(0, 0, 0, 0.25);
    border-radius: 0px;
    overflow: hidden;
    margin-top: 35px;
    padding: 0 0px;
    transition: 0.5s ease-out;

    :hover {
      transform: scale(1.05);
    }
    @media (max-width: 768px) {
      padding: 0 20px;
    }
    .accordion-item {
      background-color: transparent;
      color: #fff;
      cursor: pointer;
      width: 100%;
      border: none;
      text-align: left;
      outline: none;
      font-size: 20px;
      font-weight: 600;
      transition: 0.4s;
      padding: 35px 30px;
      padding-right: 40px;
      position: relative;
      @media (max-width: 600px) {
        font-size: 16px;
      }
      :after {
        content: "";
        position: absolute;
        width: 30px;
        height: 30px;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        background: url("https://api.iconify.design/akar-icons/plus.svg?color=white")
          no-repeat center center / contain;
      }
    }
    .active {
      :after {
        content: "";
        position: absolute;
        width: 30px;
        height: 30px;
        top: 50%;
        transform: translateY(-50%);
        background: url("https://api.iconify.design/akar-icons/minus.svg?color=white")
          no-repeat center center / contain;
      }
    }
    .panel {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.3s ease-out;
      p {
        box-shadow: 0px 4px 43px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        padding: 20px 30px;
        margin-top: 0px;
        margin-bottom: 20px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        @media (max-width: 600px) {
          font-size: 15px;
        }
      }
    }
  }
`;

export default Wrapper;
